import config from 'config/config';

export default () =>
    config.app.languages.reduce((initialValues, lang) => {
        initialValues[lang] = {};
        return initialValues;
    }, {});
